module.exports = __webpack_public_path__ + "static/media/007-Reviews.55d0ad7c.gif";